
/**
 * @imports
 */
import DOMInit from '@webqit/browser-pie/src/dom/index.js';
import OOHTML from './index.js';

/**
 * @init
 */
OOHTML(DOMInit(window));